import { UntypedFormGroup } from '@angular/forms';
const FORM_TO_SESSION_MAPPING = {
  searchType: 'checkinSearchType',
  eticketNumber: 'checkinETicketNumber',
  skymilesNumber: 'checkinSkymilesNumber',
  creditcardNumber: 'checkinCreditcardNumber',
  lastName: 'checkinLastName',
  confirmationNumber: 'checkinConfirmationNumber',
  departureAirport: 'checkinDepartureAirport'
} as const;

function setSessionStorageItem(key: string, value: string): void {
  if (value) {
    sessionStorage.setItem(key, value);
  }
}

function removeSessionStorageItem(key: string, value: string): void {
  if (value) {
    sessionStorage.removeItem(key);
  }
  sessionStorage.removeItem('deepLinkFlow');
}

export function navigateToCheckInFindPNR(
  checkinWidgetForm: UntypedFormGroup,
  submitNewUrl: string
): void {
  Object.entries(FORM_TO_SESSION_MAPPING).forEach(([formKey, sessionKey]) => {
    removeSessionStorageItem(sessionKey, checkinWidgetForm.value[formKey]);
  });
  Object.entries(FORM_TO_SESSION_MAPPING).forEach(([formKey, sessionKey]) => {
    setSessionStorageItem(sessionKey, checkinWidgetForm.value[formKey]);
  });

  sessionStorage.setItem('deepLinkFlow', 'true');
  window.location.href = submitNewUrl;
}
